import { ApiOptions } from '../../api-options.decorator';

import { ApiBaseRiskModeler } from './base';

/**
 * @internal
 */
export class ApiRiskModelerEvent extends ApiBaseRiskModeler {
  @ApiOptions({ channel: 'contractSignEvents' })
  getOrchestradeSignEvent(contractId: number) {
    return this.get(`/contract/${contractId}/sign-events`);
  }

  @ApiOptions({ channel: 'contractDetailEvents' })
  getOrchestradeEventDetail(contractId: number) {
    return this.get(`/contract/${contractId}/events-detail`);
  }
}
